import { render } from "./ActivePass.vue?vue&type=template&id=6bced462"
import script from "./ActivePass.vue?vue&type=script&lang=js"
export * from "./ActivePass.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__